module.exports = global["Swiper"] = require("-!./idangerous.swiper-2.4.3.js");


//////////////////
// WEBPACK FOOTER
// ./Library/1.0/vendor/idangerous.swiper-2.4.3.js-exposed
// module id = 422
// module chunks = 44